import Api from './Api';
import IApi from './IApi';

const api: IApi = new Api();

export { api as Api };
